import XXXLJentisModifier from "./XXXLJentisModifier";
export default {
    'XXXL': XXXLJentisModifier
};
